import { connect } from 'react-redux'
import * as selector from '../../state/plan/selector'
import AlignerLabel from '../plan/AlignerLabel'
import { selectSalesOrder } from '../../../sales-order/state/detail/selector'

const mapStateToProps = (state, props) => {
    const salesOrder = selectSalesOrder(state)
    return {
        treatmentPlan: selector.selectTreatmentPlan(state),
        alignerLabelList: selector.selectAlignerLabelList(state, salesOrder),
        salesOrder,
    }
}

const mapDispatchToProps = {}


export default connect(mapStateToProps, mapDispatchToProps)(AlignerLabel)



// WEBPACK FOOTER //
// ./src/modules/treatment/component/task-widget/AlignerLabelWidgetContainer.js